import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"
import { useMediaQuery } from "~/helpers/useMediaQuery"

import { Chart } from "./components/Chart/Chart"
import { PublicAssets } from "./components/PublicAssets/PublicAssets"
import { Sistema } from "./components/Sistema/Sistema"
import styles from "./index.module.css"

export const Quotations: React.FC = () => {
  const { t } = useTranslation()
  const { mdmin } = useMediaQuery()

  return (
    <>
      <div className="container">
        <Heading as="div" className={styles.Title} like="h1">
          <Raw html={t("stock.Quotations.Title")} />
        </Heading>
      </div>

      <Sistema />
      {/*<PublicAssets />*/}
      {/*{mdmin && (*/}
      {/*  <Wrapper className="container">*/}
      {/*    <Heading as="div" className={styles.Title} like="h1">*/}
      {/*      <Raw html={t("stock.Quotations.Stock.Title")} />*/}
      {/*    </Heading>*/}
      {/*    <Chart />*/}
      {/*  </Wrapper>*/}
      {/*)}*/}
    </>
  )
}
